import React, { Component, Suspense } from 'react'
import LanguageProvider from './features/LanguageProvider'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const Main = React.lazy(() => import('./views/pages/main/Main'))
// view pages
const EventView = React.lazy(() => import('./views/pages/events/View'))

class App extends Component {
  render() {
    return (
      <LanguageProvider>
        <BrowserRouter>
          <Suspense fallback={loading}>
            <Routes>
              <Route exact path="/" element={<Main />} />
              <Route exact path="/login" name="Login Page" element={<Login />} />
              <Route exact path="/register" name="Register Page" element={<Register />} />
              <Route exact path="/404" name="Page 404" element={<Page404 />} />
              <Route exact path="/500" name="Page 500" element={<Page500 />} />
              <Route exact path="/main" name="Main" element={<Main />} />
              <Route path="*" name="Home" element={<DefaultLayout />} />
              <Route path="/events/detail/:id" name="Event View" element={<EventView />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </LanguageProvider>
    )
  }
}

export default App
